export default __webpack_public_path__ + "static/media/skirmishers_greatsword.44acf332.jpg";